import { Button, Card, Input } from "../primitives";
import { useRef, useState } from "react";
import useTimedError from "../../hooks/useTimedError";
import { useOutletContext } from "react-router-dom";
import { catchErrorParse } from "../../ErrorUtility";
import { useTranslation } from "../../hooks/useTranslation";
import { useAuthDelete } from "../../hooks/useAxios";
import { useAuth } from "../../contexts/AuthContext";
import { useDatabase } from "../../contexts/DatabaseContext";

export default function DeleteAccount() {

    const deleteRef = useRef("")
    const [loading, setLoading] = useState(false);
    const [error, setError] = useTimedError();
    const { clientData } = useOutletContext();
    const t = useTranslation();
    const { del } = useAuthDelete();
    const { currentUser, url, logout } = useAuth();
    const { createAccountActionEvent } = useDatabase();

    async function deleteAccount() {
        setLoading(true);
        if (deleteRef?.current?.value?.toLowerCase() !== "delete") {
            // TODO: Decide how to translate this.
            // Other regions might not easily be able to do this. Do we need to support every language's word for this?
            setError("Please enter 'delete' to confirm account deletion");
            setLoading(false);
            return;
        }
        if (clientData?.subscriptions?.length > 0) {
            setError(t("You must cancel your subscriptions before deleting your account."));
            setLoading(false);
            return;
        }

        const [result, error, errorCode, errorMessage] = await catchErrorParse(del, `${url}/webapp/del-user/${currentUser?.uid}`);
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message,
                    action: "delete_account",
                }
            }));
        }
        else {
            await createAccountActionEvent("delete_account");
            await logout();
        }
        setLoading(false);
    }

    return (
        <Card ctype="white">
            <Card.Header>
                <h2>{t('Delete Account')}</h2>
                <p>{t('Are you sure you want to delete your account? This action is irreversible.')}</p>
            </Card.Header>
            <Card.Body>
                {/* TODO: Translate this too */}
                <Input ref={deleteRef} type="text" labelText="Enter 'delete' to confirm" placeholder="DELETE" />
                <Button onClick={deleteAccount} disabled={loading} error={error} buttonType="danger">
                    {error ? error : t("DELETE")}
                </Button>
            </Card.Body>
        </Card>
    )
}